import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { IsSearchField } from "../../core/components/isSearchField"
import {NotificationHelper} from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { GridCustomToolBarButton } from "../../core/components/toolBar";
import React from "react";
export default class LanguageManagement extends React.Component<LanguageManagementProps, LanguageManagementState> {
    private _gridOptions = null;
    private _ogrNr: number = null;
    private _translations: {};
    private _globalSettings = false;
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { 
                    this.setState({selectedDataItem: null});
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._enableLanguage();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };
    constructor(props) {
        super(props);
        this._globalSettings = Helper.hasValue(props?.field?.props?.globalSettings) && props.field.props.globalSettings === true;
        this._gridOptions = this.props.context.languagesManagementGridOptions;
        this._ogrNr = Helper.getValueOrDefault(props.entity.OGrNr, null);
        this._setEvents();
        this.state = { gridData: [], selectedDataItem: null, dialogOpen: false };        
    }    

    private _getGridData = () => {
        let url = "Languages/GetAllGenericLanguages";
        if (Helper.hasValue(this._ogrNr)) {
            url += "?OgrNr=" + this._ogrNr;
        }
        HTTPService.get<JsonResultClass<languageInfo[]>>(url).then(result => {
            this.setState({ gridData: result.Data });
        });
    }

    private _enableLanguage = () => {
        if (Helper.hasValue(this._ogrNr)) {
            this._handleGridChange(true);
        } else {
            if (Helper.hasValue(this.state.selectedDataItem)) {
                HTTPService.post("Languages/EnableLanguage", { "LangId": this.state.selectedDataItem.Id, "OgrNr": this._ogrNr }).then(result => {
                    this._getGridData();
                });
            }
        }
    }

    private _disableLanguage = () => {
        if (Helper.hasValue(this._ogrNr)) {
            this._handleGridChange(false);
        } else {
            if (Helper.hasValue(this.state.selectedDataItem)) {
                HTTPService.post("Languages/DisableLanguage", { "LangId": this.state.selectedDataItem.Id, "OgrNr": this._ogrNr }).then(result => {
                    this._getGridData();
                });
            }
        }
    }

    private _removeLanguage = () => {
            if (Helper.hasValue(this.state.selectedDataItem)) {
                HTTPService.post("Languages/RemoveLanguage", { "LangId": this.state.selectedDataItem.Id }).then(result => {
                    this._getGridData();
                });
            }
    }

    private _handleGridChange = (enable: boolean) => {
        $(window).trigger("MainGroupEntityChanged", { update: true });       
        let gridData = this.state.gridData;
        let index: number = -1;
        for (let i = 0; i < gridData.length; i++) {
            if (gridData[i].Code === this.state.selectedDataItem.Code) {
                index = i;
                break;
            }
        }
        if (index > -1) {
            gridData[index].Enabled = enable ? 1 : 0;
        } else {
            let item = this.state.selectedDataItem;
            item.Enabled = enable ? 1 : 0;
            gridData.push(item);
            gridData.sort((a, b) => {
                if (a.Id < b.Id) {
                    return -1;
                } else if (a.Id > b.Id) {
                    return 1;
                } else {
                    return 0;
                }
            });
            let newEntity = this.props.entity;
            let values = newEntity.LanguageDependentParameters;
            values.push({
                Description: null,
                Language: {
                    Id: item.Id,
                    LanguageName: item.Name
                },
                Name: null
            });
            $(window).trigger("AddLanguageToMainGroup", {
                update: true
            });   
        }
        this.setState({ gridData: gridData });
    } 

    private _saveLanguages = () => {
        HTTPService.post("Languages/SaveLanguageByMainGroup", { "OgrNr": this._ogrNr, "lst": this.state.gridData }).then(result => {
            this._getGridData();
        });
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createSearchTextBox()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createSearchTextBox = () => {

        const template: string = "<table cellspacing='0' style='table-layout:fixed; width:250px'>" +
	                                "<colgroup>" +
		                                "<col style='width: 100px' />" +
                                        "<col style='width: 150px' />" +
                                        "<col style='width: 150px' />" +
	                                "</colgroup>" +
	                                    "<tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'>" +
		                                    "<td style='vertical-align:top; word-wrap: break-word;'>${data.Code}</td>" + 
                                            "<td style='vertical-align:top'>${data.EnglishName}</td>" +
                                            "<td style='vertical-align:top'>${data.NativeName}</td>" +
	                                    "</tr>" +
                                 "</table>";


        let props = this._factory.getDefaultSearchFieldProps();
        props.field.searchButtonEnabled = false;
        props.field.listWidth = 400; //because why not
        props.field.autocompleteEnabled = true;
        props.field.autocompleteTemplate = template;
        props.field.autocompleteUrl = Helper.hasValue(this._ogrNr) ? "Languages/FindByMainGroup?OGrNr=" + this._ogrNr : "Languages/FindGeneral";
        props.field.autocompleteDataTextField = "Name";

        if (Helper.hasValue(this.state.selectedDataItem)) {
            props.value = Helper.getValueOrDefault(this.state.selectedDataItem.Name, "");
        } else {
            props.value = "";
        }
        props.onChange = (field: { model: string }, value: any, dataItem?: languageInfo) => {
            this.setState({ selectedDataItem: dataItem });
        }
        return (
            <FieldInstance label={this._translations["Parts.TranslationLink.LabelLanguage"]} noHover={true}>
                <IsSearchField {...props} />
            </FieldInstance>
        );
    }

    private _createGrid = () => {
        if (Helper.hasValue(this._translations)) {
            let caption = this._translations["Standard.Enable"];
            let icon = "k-i-check"; 
            if (Helper.hasValue(this.state.selectedDataItem)) {
                caption = (this.state.selectedDataItem.Enabled == 1) ? this._translations["Standard.Disable"] : this._translations["Standard.Enable"];
                icon = (this.state.selectedDataItem.Enabled == 1) ? "k-i-close" : "k-i-check";
            }
            const customButtons: Array<GridCustomToolBarButton> = [];
            if (this._globalSettings)
                customButtons.push({ id: "add", enabled: true, caption: this._translations["Standard.Add"], autoEnabledOnRecordSelected: false, iconClass: "k-i-plus" });
            if (this._globalSettings && false)
                customButtons.push({ id: "remove", enabled: Helper.hasValue(this.state.selectedDataItem), caption: this._translations["Standard.Loeschen"], autoEnabledOnRecordSelected: false, iconClass: "k-i-minus" });
            customButtons.push({ id: "change", enabled: Helper.hasValue(this.state.selectedDataItem), caption: caption, autoEnabledOnRecordSelected: false, iconClass: icon });
            if (this._globalSettings)
                customButtons.push({ id: "update_views", enabled: true, caption: this._translations["WebSMS.UserSettings.MainGroup.UpdateViews"], autoEnabledOnRecordSelected: false, iconClass: "k-i-page-properties" });
            const style: React.CSSProperties = {
                height: 400
            }
            let grid = (
                <div style={style}>
                    <Grid data={this.state.gridData} options={this._gridOptions} id="languageInfo" selectFilter={this.state.selectedDataItem == null ? null : this.state.selectedDataItem.Name}
                        onSelectionChanged={this._onSelectedChange} customButtons={customButtons} onClickCustomButton={this._handleClickCustomButton} />
                </div>
            );
            return (grid)
        } else {
            return null;
        }
    }

    private _onSelectedChange = (dataItem: languageInfo) => {
        if (Helper.hasValue(dataItem))
            this.setState({ selectedDataItem: dataItem });
    }

    private _handleClickCustomButton = (id: string, dataItem: languageInfo, dataItems: Array<any>) => {
        switch (id) {
            case ("add"):
                this.props.entity.UpdateTranslationViews = true;
                this.setState({ dialogOpen: true, selectedDataItem: null });
                break;
            case ("remove"):
                this.props.entity.UpdateTranslationViews = true;
                this._removeLanguage();
                break;
            case ("change"):
                if (this.state.selectedDataItem.Enabled == 1) {
                    this._disableLanguage();
                } else {
                    this._enableLanguage();
                }
                break;
            case ("update_views"):
                HTTPService.post<JsonResultClass>("Languages/UpdateTranslations")
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
                break;
        }
    }

    private _setEvents = () => {
        $(window).on("SaveLangugesByMainGroup", (e, d) => {
            if (d.update) {
                this._saveLanguages();
            }
        });
        $(window).on("ReloadLanguages", (e, d) => {
            if (d.update && !Helper.hasValue(this._ogrNr)) {
                this._getGridData();
            }
        });
    }

    componentDidMount() {
        this._gridOptions = this.props.context.languagesManagementGridOptions;
        this._translations = this.props.context.translations;
        this._dialogProps.title = this._translations["Standard.Add"];
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : null;
        return (
            <>
                {grid}
                {dialog}
            </>
        );
    }
}


interface LanguageManagementState {
    selectedDataItem: languageInfo;    
    gridData: languageInfo[];
    dialogOpen: boolean;
}

interface LanguageManagementProps {
    context: ContextGeneralSettingsApp;
    entity: any;
}

interface languageInfo {
    Id: number;
    Code: string;
    Name: string;
    Enabled: number;
}




